let clienttypelist = ["Company", "Customer"];
export default clienttypelist;
